module.exports = __webpack_public_path__ + "static/media/blurredtext.939a47c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blurredtext.png
// module id = 1900
// module chunks = 2